import Mn from 'backbone.marionette';

const template = require('./403.pug');

export default Mn.View.extend({
  template(data: {}) {
    return template(data);
  },
});
